import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root &>div": {
      paddingTop: 5,
      paddingBottom: 0,
    },
  },
  input: {
    height: 86,
  },
  container: {
    width: "100%",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    paddingRight: "10px",
  },
  link: {
    cursor: "pointer",
    "a&": {
      display: "inline",
    },
    "span&": {
      display: "block",
    },
  },
  infoIconContainer: {
    height: 32,
    width: 32,
    display: "inline-block",
    verticalAlign: "top",
    marginTop: -8,
  },
  actionButtons: {
    width: 74,
    "& > button": {
      display: "inline-block",
      "&:first-child": {
        marginRight: 10,
      },
    },
  },
  errorBanner: {
    position: "relative",
    top: 0,
    marginTop: 10,
    paddingBottom: 20,
    zIndex: 1,
  },
}));

export default useStyles;
